/**
 * The app shells (ADR 0007): the Android app is a Capacitor shell around this web app, and says so
 * in its user agent ("ObeanApp/2"). A web release that needs something only a newer shell has (a
 * native plugin, a permission) raises the minimum here, in the same release, and older shells
 * get a friendly "please update" instead of something broken (P4-APP-08). The release routine
 * (P4-APP-07) says when.
 */

export type ShellPlatform = "android";

/** The oldest shell each platform's app can still run this web release in. */
export const MIN_SHELL: Record<ShellPlatform, number> = { android: 1 };

/** Where to update it. The app id is provisional until its first Play upload (capacitor.config). */
export const STORE_URL: Record<ShellPlatform, string> = {
  android: "https://play.google.com/store/apps/details?id=com.obean.app",
};

export interface Shell {
  platform: ShellPlatform;
  version: number;
}

/** The app shell this page runs in, from the user agent; null in a browser. */
export function appShell(userAgent: string): Shell | null {
  const m = /\bObeanApp(?:\/(\d+))?\b/.exec(userAgent);
  if (!m) return null;
  // The first shells said only "ObeanApp": they're version 1.
  return { platform: "android", version: m[1] ? Number(m[1]) : 1 };
}

/** The shell is older than this release supports: show the update screen, not the app. */
export const shellTooOld = (shell: Shell | null, min = MIN_SHELL): boolean =>
  shell !== null && shell.version < min[shell.platform];
